<template>
  <div style="margin: 0 2%">
    <div class="mt-3 mb-3 px-3 header">
      <div style="display: flex; flex-direction: row; align-items: center">
        <div>
          <h2 class="grey--text text--lighten-3 hidden-xs-only">
            Construyamos juntos el calendario de suministro<br />más grande de
            Colombia
          </h2>
          <h2 class="grey--text text--lighten-3 d-flex d-sm-none">
            Construyamos juntos el calendario de suministro más grande de
            Colombia
          </h2>
          <p
            class="grey--text text--lighten-2 detalle-metricas"
            style="font-size: 15pt"
          >
            <b>+3.100</b> Productores - <b>{{ productos.length }}</b> Productos
            - <b>{{ producciones.length }}</b> Producciones Registradas
          </p>
        </div>
      </div>
      <div class="buttons-registro">
        <v-btn
          color="primary"
          class="registro-btn mr-3 mb-3"
          @click="irRegistroProductor"
          >Registrarme como Productor(a)</v-btn
        >
        <v-btn
          color="primary"
          class="registro-btn mb-3"
          @click="irRegistroComprador"
          >Registrarme como Comprador(a)</v-btn
        >
      </div>
    </div>
    <div>
      <v-card :color="$vuetify.theme.themes.dark.secondary">
        <v-card-text>
          <v-row>
            <!-- CALENDARIO -->
            <v-col class="pt-0" xs="12" sm="9" md="9" lg="9" xl="9">
              <!-- FILTROS BUSQUEDA -->
              <v-row class="mb-2 d-flex d-sm-none">
                <v-col
                  cols="12"
                  xs="12"
                  sm="12"
                  md="12"
                  lg="12"
                  xl="12"
                  class="pt-2"
                >
                  <v-autocomplete
                    v-model="selectionProducto"
                    :items="productos"
                    chips
                    clearable
                    hide-details="auto"
                    hide-selected
                    item-text="nombre"
                    item-value="idProducto"
                    label="¿Que producto buscas?"
                    outlined
                  >
                    <template v-slot:selection="{ attr, on, item, selected }">
                      <v-chip
                        pill
                        v-bind="attr"
                        :input-value="selected"
                        :color="item.color"
                        class="white--text"
                        v-on="on"
                      >
                        <v-avatar left>
                          <v-img :src="item.imagen"></v-img>
                        </v-avatar>
                        <span v-text="item.nombre"></span>
                      </v-chip>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title
                          >{{ item.nombre }} ({{
                            item.counter
                          }})</v-list-item-title
                        >
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  xs="12"
                  sm="12"
                  md="12"
                  lg="12"
                  xl="12"
                  class="pt-2"
                >
                  <v-select
                    v-model="selectionDepartamento"
                    hide-details="auto"
                    item-value="id_departamento"
                    item-text="nombre"
                    :items="departamentos"
                    label="¿En que departamento?"
                    outlined
                    chips
                    clearable
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title
                          >{{ item.nombre }} ({{
                            item.counter
                          }})</v-list-item-title
                        >
                      </v-list-item-content>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
              <vue-cal
                :selected-date="selectedDate"
                style="height: 1000px"
                :time="false"
                :disable-views="['years']"
                locale="es"
                :events="events"
                events-count-on-year-view
                :on-event-click="onEventClick"
                today-button
              />
            </v-col>
            <!-- DETALLES PRODUCCION -->
            <v-col class="pt-0 hidden-xs-only" cols="3">
              <!-- FILTROS BUSQUEDA -->
              <v-row class="mb-2">
                <v-col
                  cols="12"
                  xs="12"
                  sm="12"
                  md="12"
                  lg="12"
                  xl="12"
                  class="pt-2"
                >
                  <v-autocomplete
                    v-model="selectionProducto"
                    :items="productos"
                    chips
                    clearable
                    hide-details="auto"
                    hide-selected
                    item-text="nombre"
                    item-value="idProducto"
                    label="¿Que producto buscas?"
                    outlined
                  >
                    <template v-slot:selection="{ attr, on, item, selected }">
                      <v-chip
                        pill
                        v-bind="attr"
                        :input-value="selected"
                        :color="item.color"
                        class="white--text"
                        v-on="on"
                      >
                        <v-avatar left>
                          <v-img :src="item.imagen"></v-img>
                        </v-avatar>
                        <span v-text="item.nombre"></span>
                      </v-chip>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title
                          >{{ item.nombre }} ({{
                            item.counter
                          }})</v-list-item-title
                        >
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  xs="12"
                  sm="12"
                  md="12"
                  lg="12"
                  xl="12"
                  class="pt-2"
                >
                  <v-select
                    v-model="selectionDepartamento"
                    hide-details="auto"
                    item-value="id_departamento"
                    item-text="nombre"
                    :items="departamentos"
                    label="¿En que departamento?"
                    outlined
                    chips
                    clearable
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title
                          >{{ item.nombre }} ({{
                            item.counter
                          }})</v-list-item-title
                        >
                      </v-list-item-content>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
              <!-- DETALLE PRODUCCION -->
              <div
                class="mt-5"
                v-if="selectedProduccion"
                style="height: 100%; display: flex; flex-direction: column"
              >
                <div class="mb-6">
                  <div style="text-align: center">
                    <v-avatar size="130">
                      <img :src="selectedProduccion.producto.imagen" />
                    </v-avatar>
                  </div>
                </div>
                <div style="text-align: center; color: #e0e0e0">
                  <p
                    class="mb-3"
                    style="font-size: 25pt; font-weight: 500; line-height: 30px"
                  >
                    {{ selectedProduccion.producto.nombre }}
                  </p>
                  <p class="mb-2" style="font-size: 15pt">
                    {{
                      selectedProduccion.dataProduccion.extension.extensionText
                    }}
                  </p>
                  <p class="mb-2" style="font-size: 15pt">
                    Producción del {{ selectedProduccion.fechaInicio }}
                    <br />
                    al {{ selectedProduccion.fechaFin }}
                  </p>
                  <div
                    v-if="selectedProduccion.dataProduccion.proximoRangoCosecha"
                  >
                    <p
                      v-if="
                        selectedProduccion.dataProduccion.proximoRangoCosecha
                          .volumen
                      "
                      style="font-size: 15pt"
                    >
                      {{
                        selectedProduccion.dataProduccion.proximoRangoCosecha
                          .volumen.valor
                      }}
                      <span
                        v-if="
                          selectedProduccion.dataProduccion.proximoRangoCosecha
                            .volumen.unidad
                        "
                        >{{
                          selectedProduccion.dataProduccion.proximoRangoCosecha
                            .volumen.unidad.Id
                        }}</span
                      >
                      <span
                        v-if="
                          selectedProduccion.dataProduccion.proximoRangoCosecha
                            .volumen.frecuencia
                        "
                        >por
                        {{
                          selectedProduccion.dataProduccion.proximoRangoCosecha
                            .volumen.frecuencia.nombre.sin
                        }}</span
                      >
                    </p>
                  </div>
                  <p class="mb-2 mt-4" style="font-size: 20pt">
                    {{ selectedProduccion.productor.nombres.primero }}
                    {{ selectedProduccion.productor.apellidos.primero }}
                  </p>
                  <p class="mb-2" style="font-size: 15pt">
                    Finca {{ selectedProduccion.finca.nombre }}
                  </p>
                  <p class="mb-6" style="font-size: 15pt">
                    {{ selectedProduccion.finca.ubicacion }}
                  </p>
                  <v-btn
                    depressed
                    large
                    color="primary"
                    @click="openSolicitar()"
                    >Solicitar</v-btn
                  >
                </div>
              </div>
            </v-col>
          </v-row>
          <!-- COMPRADORES -->
          <v-row class="mt-3">
            <v-col cols="12">
              <div class="mb-5 compradores-header">
                <p style="font-size: 16pt; font-weight: 600">
                  {{ compradores.length }} Compradores
                </p>
                <v-btn class="ml-4" color="primary" @click="irRegistroComprador"
                  >Registrarme como Comprador(a)</v-btn
                >
              </div>

              <div
                class="container-carousel pb-2"
                style="display: flex; flex-direction: row; overflow-x: auto"
              >
                <div v-for="emp in compradores" :key="emp.idEmpresa">
                  <v-card
                    @click="openVerDemanda(emp)"
                    class="mx-2"
                    color="#36343f"
                    style="width: 170px; height: 248px; cursor: pointer"
                  >
                    <v-card-text style="text-align: center; height: 100%">
                      <v-avatar size="80">
                        <img style="object-fit: contain" :src="emp.imagen" />
                      </v-avatar>
                      <p
                        class="mt-3 mb-1"
                        style="text-align: center; font-size: 12pt"
                      >
                        {{ emp.nombre }}
                      </p>
                      <p
                        class="mb-2"
                        style="text-align: center; font-size: 12pt"
                      >
                        {{ emp.totalVolumenComprador }}
                      </p>
                      <p
                        class="mb-1"
                        style="text-align: center; font-size: 10pt"
                      >
                        {{ emp.ubicacion }}
                      </p>
                    </v-card-text>
                  </v-card>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <div class="mt-2 mb-4">
        <p
          class="grey--text text--lighten-1 mb-0 mt-1"
          style="text-align: center"
        >
          Producto desarrollado por Cultivando Futuro SAS
        </p>
        <div>
          <a target="_blank" href="https://cultivandofuturo.com">
            <v-img
              style="width: 180px; display: block; margin: 0 auto"
              src="https://resources.cultivandofuturo.com/cultivandofuturo-large-info-white.png"
            ></v-img>
          </a>
        </div>
        <p
          class="grey--text text--lighten-1 mb-0 mt-1"
          style="text-align: center"
        >
          Copyright © 2014-2020 Cultivando Futuro S.A.S -
          agro@cultivandofuturo.com -
          <a
            target="_blank"
            href="https://app.cultivandofuturo.com/documentos-legales/terminos-condiciones"
            >Términos y Condiciones</a
          >
        </p>
      </div>
    </div>
    <v-dialog v-model="dialogDetalleProduccion" persistent max-width="500px">
      <v-card :color="$vuetify.theme.themes.dark.secondary">
        <v-card-title style="position: relative">
          <v-col class="pb-1 pt-1 px-0">
            <p class="mb-0" style="font-weight: 600; font-size: 20pt">
              Detalle Producción
            </p>
          </v-col>
          <div style="position: absolute; top: 18px; right: 16px">
            <v-btn @click="dialogDetalleProduccion = false" icon color="white">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <v-container class="pt-0">
            <v-row>
              <v-col>
                <div
                  v-if="selectedProduccion"
                  style="
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                  "
                >
                  <div class="mb-6">
                    <div style="text-align: center">
                      <v-avatar size="150">
                        <img :src="selectedProduccion.producto.imagen" />
                      </v-avatar>
                    </div>
                  </div>
                  <div style="text-align: center; color: #e0e0e0">
                    <p
                      class="mb-3"
                      style="
                        font-size: 25pt;
                        font-weight: 500;
                        line-height: 30px;
                      "
                    >
                      {{ selectedProduccion.producto.nombre }}
                    </p>
                    <p class="mb-2" style="font-size: 15pt">
                      {{
                        selectedProduccion.dataProduccion.extension
                          .extensionText
                      }}
                    </p>
                    <p class="mb-2" style="font-size: 15pt">
                      Producción del {{ selectedProduccion.fechaInicio }}
                      <br />
                      al {{ selectedProduccion.fechaFin }}
                    </p>
                    <div
                      v-if="
                        selectedProduccion.dataProduccion.proximoRangoCosecha
                      "
                    >
                      <p
                        v-if="
                          selectedProduccion.dataProduccion.proximoRangoCosecha
                            .frecuencia
                        "
                        style="font-size: 15pt"
                      >
                        {{
                          selectedProduccion.dataProduccion.proximoRangoCosecha
                            .volumen.valor
                        }}
                        {{
                          selectedProduccion.dataProduccion.proximoRangoCosecha
                            .volumen.unidad.Id
                        }}
                        por
                        {{
                          selectedProduccion.dataProduccion.proximoRangoCosecha
                            .frecuencia.nombre.sin
                        }}
                      </p>
                    </div>
                    <p class="mb-2 mt-4" style="font-size: 20pt">
                      {{ selectedProduccion.productor.nombres.primero }}
                      {{ selectedProduccion.productor.apellidos.primero }}
                    </p>
                    <p class="mb-2" style="font-size: 15pt">
                      Finca {{ selectedProduccion.finca.nombre }}
                    </p>
                    <p class="mb-6" style="font-size: 15pt">
                      {{ selectedProduccion.finca.ubicacion }}
                    </p>
                    <v-btn
                      depressed
                      large
                      color="primary"
                      @click="openSolicitar()"
                      >Solicitar</v-btn
                    >
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSolicitar" persistent max-width="600px">
      <v-card
        v-if="selectedProduccion"
        :color="$vuetify.theme.themes.dark.secondary"
      >
        <v-card-title style="position: relative">
          <v-col class="pb-0">
            <span style="font-weight: 600; font-size: 20pt"
              >Solicitar {{ selectedProduccion.producto.nombre }}</span
            >
          </v-col>
          <div style="position: absolute; top: 25px; right: 25px">
            <v-btn @click="dialogSolicitar = false" icon color="white">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <v-container class="pt-0">
            <v-row style="font-size: 12pt">
              <v-col>
                <p
                  class="mb-2 grey--text text--lighten-4"
                  style="font-size: 15pt; line-height: 28px"
                >
                  Bienvenido a
                  <b>Cultivando Futuro</b>, cuentanos un poco más de tus
                  necesidades para contactarte y hacer parte de nuestra red.
                </p>
                <p
                  class="mb-0 grey--text text--lighten-4"
                  style="font-size: 15pt; line-height: 28px"
                >
                  Producción por
                  {{ selectedProduccion.productor.nombres.primero }}
                  {{ selectedProduccion.productor.apellidos.primero }} de
                  {{ selectedProduccion.finca.ubicacion }}
                </p>
              </v-col>
            </v-row>
            <v-form ref="solicitarProductoForm">
              <v-row>
                <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                  <v-text-field
                    v-model="solicitarProducto.empresa"
                    label="Nombre Empresa"
                    outlined
                    hide-details="auto"
                    :rules="[rules.required]"
                    type="text"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                  <v-text-field
                    v-model="solicitarProducto.contacto.nombre"
                    label="Persona de Contacto"
                    outlined
                    hide-details="auto"
                    type="text"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                  <v-text-field
                    v-model="solicitarProducto.contacto.telefono"
                    label="Telefono"
                    outlined
                    hide-details="auto"
                    type="number"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                  <v-text-field
                    v-model="solicitarProducto.contacto.email"
                    label="Correo Electronico"
                    outlined
                    :rules="[rules.required, rules.email]"
                    hide-details="auto"
                    type="email"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                  <v-textarea
                    v-model="solicitarProducto.productos"
                    rows="3"
                    outlined
                    label="Información adicional u otros productos requeridos"
                    :rules="[rules.required]"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>

            <div class="text-center">
              <v-btn
                :loading="loadingSolicitar"
                @click="sendInformationSolicitar(solicitarProducto)"
                large
                color="primary"
                >Enviar Información</v-btn
              >
            </div>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDetalleDemanda" persistent max-width="600px">
      <v-card :color="$vuetify.theme.themes.dark.secondary">
        <v-card-title style="position: relative">
          <v-col class="pb-1 pt-1 px-0">
            <p class="mb-0" style="font-weight: 600; font-size: 20pt">
              Detalle Demanda
            </p>
          </v-col>
          <div style="position: absolute; top: 18px; right: 16px">
            <v-btn @click="dialogDetalleDemanda = false" icon color="white">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <v-container class="pt-0">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Imagen</th>
                    <th class="text-left">Producto</th>
                    <th class="text-left">Demanda</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in selectedEmpresa.productos"
                    :key="item.producto.idProducto"
                  >
                    <td class="py-2">
                      <v-avatar>
                        <img :src="item.producto.imagen" />
                      </v-avatar>
                    </td>
                    <td>{{ item.producto.nombre }}</td>
                    <td>{{ item.volumen }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogComprador" persistent max-width="600px">
      <v-card :color="$vuetify.theme.themes.dark.secondary">
        <v-card-title style="position: relative">
          <v-col class="pb-0">
            <span style="font-weight: 600; font-size: 20pt"
              >Soy Comprador(a)</span
            >
          </v-col>
          <div style="position: absolute; top: 25px; right: 25px">
            <v-btn @click="dialogComprador = false" icon color="white">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <v-container class="pt-0">
            <v-row style="font-size: 12pt">
              <v-col>
                <p
                  class="mb-2 grey--text text--lighten-4"
                  style="font-size: 15pt; line-height: 28px"
                >
                  Bienvenido a
                  <b>Cultivando Futuro</b>, cuentanos un poco más de tus
                  necesidades para contactarte y hacer parte de nuestra red.
                </p>
              </v-col>
            </v-row>
            <v-form ref="solicitarProductoComprador">
              <v-row>
                <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                  <v-text-field
                    v-model="solicitarProducto.empresa"
                    label="Nombre Empresa"
                    outlined
                    hide-details="auto"
                    :rules="[rules.required]"
                    type="text"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                  <v-text-field
                    v-model="solicitarProducto.contacto.nombre"
                    label="Persona de Contacto"
                    outlined
                    hide-details="auto"
                    type="text"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                  <v-text-field
                    v-model="solicitarProducto.contacto.telefono"
                    label="Telefono"
                    outlined
                    hide-details="auto"
                    type="number"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                  <v-text-field
                    v-model="solicitarProducto.contacto.email"
                    label="Correo Electronico"
                    outlined
                    :rules="[rules.required, rules.email]"
                    hide-details="auto"
                    type="email"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                  <v-textarea
                    v-model="solicitarProducto.productos"
                    rows="3"
                    outlined
                    label="Información adicional u otros productos requeridos"
                    :rules="[rules.required]"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>

            <div class="text-center">
              <v-btn
                :loading="loadingSolicitar"
                @click="sendInformationComprador()"
                large
                color="primary"
                >Enviar Información</v-btn
              >
            </div>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar.show"
      bottom
      :color="snackbar.color"
      :timeout="5000"
      >{{ snackbar.text }}</v-snackbar
    >
  </div>
</template>

<script>
// import HelloWorld from "@/components/HelloWorld.vue";

import api from "@/api/api";
import _ from "lodash";
import VueCal from "vue-cal";
import "vue-cal/dist/i18n/es.js";
import "vue-cal/dist/vuecal.css";
import moment, { locale } from "moment";

moment.locale("es");

const timezone = "America/Bogota";

export default {
  name: "Calendario",
  components: { VueCal },
  data: () => ({
    producciones: [],
    produccionesFilt: [],
    selectedEvent: null,
    selectedProduccion: null,
    selectedDate: moment().format("YYYY-MM-D"),
    selectionProducto: null,
    selectionDepartamento: null,
    dialogDetalleProduccion: false,
    dialogSolicitar: false,
    rules: {
      required: (value) => !!value || "Campo Requerido",
      requiredMultiple: (value) => {
        if (value.length > 0) {
          return true;
        } else {
          return "Debes seleccionar al menos un item.";
        }
      },
      counter: (value) => value.length <= 20 || "Max 20 characters",
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "No es un email válido";
      },
      counter6: (value) =>
        value.length == 6 || "El código debe contener 6 digitos",
    },
    solicitarProducto: {
      empresa: null,
      contacto: {
        nombre: null,
        telefono: null,
        email: null,
      },
      productos: null,
    },
    loadingSolicitar: false,
    snackbar: {
      show: false,
      text: null,
      color: null,
    },
    compradores: [],
    dialogDetalleDemanda: false,
    selectedEmpresa: null,
    dialogComprador: false,
  }),
  mounted() {
    this.getProducciones();
    this.getCompradores();
    // console.log(process.env);
  },
  methods: {
    async getProducciones() {
      let producciones = await api.getProducciones();
      this.producciones = producciones;
      this.produccionesFilt = producciones;
    },
    irHome() {
      this.$router.push({ path: "/" });
    },
    onEventClick(event, e) {
      this.selectedEvent = event;

      this.selectedProduccion = this.producciones.find(
        (prod) => prod.idProduccion == event.idProduccion
      );

      console.log(this.selectedProduccion);

      if (this.breakpoint == "xs") {
        this.dialogDetalleProduccion = true;
      }

      e.stopPropagation();
    },
    volver() {
      this.$router.push({ path: "/" });
    },
    openSolicitar() {
      this.dialogSolicitar = true;
    },
    async sendInformationSolicitar() {
      if (this.$refs.solicitarProductoForm.validate()) {
        this.solicitarProducto.selectedProduccion = this.selectedProduccion;
        try {
          this.loadingSolicitar = true;
          await api.solicitarProducto(this.solicitarProducto, true);
          this.loadingSolicitar = false;
          this.dialogSolicitar = false;
          this.solicitarProducto = {
            empresa: null,
            contacto: {
              nombre: null,
              telefono: null,
              email: null,
            },
            productos: null,
          };
        } catch (err) {
          console.log(err);
        }
      }
    },
    async sendInformationComprador() {
      if (this.$refs.solicitarProductoComprador.validate()) {
        try {
          this.loadingSolicitar = true;
          await api.solicitarProducto(this.solicitarProducto, false);
          this.loadingSolicitar = false;
          this.dialogComprador = false;
          this.solicitarProducto = {
            empresa: null,
            contacto: {
              nombre: null,
              telefono: null,
              email: null,
            },
            productos: null,
          };
        } catch (err) {
          console.log(err);
        }
      }
    },
    showSnackbar(message, color) {
      this.snackbar.text = message;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },
    async getCompradores() {
      try {
        let data = await api.getCompradores();
        this.compradores = data;
        // console.log(data);
      } catch (err) {
        console.log(err);
      }
    },
    openVerDemanda(emp) {
      this.selectedEmpresa = emp;
      this.dialogDetalleDemanda = true;
    },
    irRegistroProductor() {
      this.$router.push({ path: "registro" });
    },
    irRegistroComprador() {
      this.$router.push({ path: "registro-comprador" });
    },
  },
  computed: {
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    productos() {
      let productos = this.producciones.map((prod) => {
        return prod.producto;
      });

      let productosUniq = _.uniqBy(productos, "slug");

      for (var producto of productosUniq) {
        producto.counter = 0;

        for (const production of this.producciones) {
          if (production.producto.idProducto == producto.idProducto) {
            producto.counter++;
          }
        }
      }

      // console.log(productosUniq);

      return _.sortBy(productosUniq, [
        function (o) {
          return o.nombre;
        },
      ]);
    },
    departamentos() {
      let depts = this.producciones.map((prod) => {
        return prod.finca.departamento;
      });

      let deptsUniq = _.uniqBy(depts, "id_departamento");

      for (var dept of deptsUniq) {
        dept.counter = 0;
        for (const prod of this.producciones) {
          if (prod.finca.departamento.id_departamento == dept.id_departamento) {
            dept.counter++;
          }
        }
      }

      // console.log(deptsUniq);

      return _.sortBy(deptsUniq, [
        function (o) {
          return o.nombre;
        },
      ]);
    },
    events() {
      let events = [];
      this.produccionesFilt.forEach((prod) => {
        let obj = {
          idProduccion: prod.idProduccion,
          idProducto: prod.idProducto,
          idDepartamento: prod.finca.departamento.id_departamento,
          start: moment(prod.dataProduccion.rangoVisibilidad.fechaInicio)
            .startOf("day")
            .format("YYYY-MM-D H:mm"),
          end: moment(prod.dataProduccion.rangoVisibilidad.fechaFin)
            .endOf("day")
            .format("YYYY-MM-D H:mm"),
          title: `${prod.producto.nombre}`,
          class: `producto-${prod.producto.slug}`,
        };

        if (
          moment(prod.dataProduccion.rangoVisibilidad.fechaInicio).isBefore(
            moment()
          )
        ) {
          obj.start = moment().startOf("day").format("YYYY-MM-D H:mm");
        }

        events.push(obj);
      });
      return events;
    },
  },
  watch: {
    selectionProducto(val) {
      let vm = this;

      if (val) {
        if (this.selectionDepartamento) {
          let producciones = this.producciones.filter(
            (prod) =>
              prod.idProducto == val &&
              prod.finca.departamento.id_departamento ==
                vm.selectionDepartamento
          );

          if (producciones.length == 0) {
            vm.showSnackbar("No hay producciones que cumplan con tu búsqueda");
          }

          this.produccionesFilt = producciones;

          let items = this.events.filter(
            (event) =>
              event.idProducto == val &&
              event.idDepartamento == vm.selectionDepartamento
          );

          if (items.length > 0) {
            this.selectedDate = items[0].start;
          }
        } else {
          let producciones = this.producciones.filter(
            (prod) => prod.idProducto == val
          );
          console.log(producciones);
          this.produccionesFilt = producciones;

          let items = this.events.filter((event) => event.idProducto == val);
          if (items.length > 0) {
            this.selectedDate = items[0].start;
          }
        }
      } else {
        this.produccionesFilt = this.producciones;
      }
    },
    selectionDepartamento(val) {
      let vm = this;
      if (val) {
        if (vm.selectionProducto) {
          let producciones = this.producciones.filter(
            (prod) =>
              prod.finca.departamento.id_departamento == val &&
              prod.idProducto == vm.selectionProducto
          );

          if (producciones.length == 0) {
            vm.showSnackbar(
              "No hay producciones que cumplan con tu búsqueda",
              "red"
            );
          }

          this.produccionesFilt = producciones;

          let items = this.events.filter(
            (event) =>
              event.idDepartamento == val &&
              event.idProducto == vm.selectionProducto
          );

          if (items.length > 0) {
            this.selectedDate = items[0].start;
          }
        } else {
          let producciones = this.producciones.filter(
            (prod) => prod.finca.departamento.id_departamento == val
          );

          this.produccionesFilt = producciones;

          let items = this.events.filter(
            (event) => event.idDepartamento == val
          );
          this.selectedDate = items[0].start;
        }
      } else {
        this.produccionesFilt = this.producciones;
      }
    },
    selectedProduccion(val) {
      this.selectedProduccion.fechaInicio = moment(
        val.dataProduccion.rangoVisibilidad.fechaInicio
      ).format("D MMM YYYY");
      this.selectedProduccion.fechaFin = moment(
        val.dataProduccion.rangoVisibilidad.fechaFin
      ).format("D MMM YYYY");
    },
  },
};
</script>

<style>
@media (max-width: 599px) {
  .header {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .header h2 {
    font-size: 25pt;
    text-align: center;
    margin-bottom: 15px;
  }
  .detalle-metricas {
    text-align: center;
  }
  .header .buttons-registro {
    display: flex;
    flex-direction: column;
  }
  .detalle-metricas {
    margin-bottom: 10px;
  }
  .compradores-header {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .compradores-header p {
    margin-bottom: 20px;
  }
}
@media (min-width: 600px) and (max-width: 959px) {
  .header {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .detalle-metricas {
    margin-bottom: 0 !important;
  }
  .compradores-header {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .compradores-header p {
    margin-bottom: 20px;
  }
}
@media (min-width: 960px) and (max-width: 1247px) {
  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .header h2 {
    font-size: 32pt;
    text-align: center;
    margin-bottom: 15px;
  }
  .detalle-metricas {
    margin-bottom: 20px !important;
    text-align: center;
  }
  .compradores-header {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .compradores-header p {
    margin-bottom: 0 !important;
  }
}
@media (min-width: 1248px) and (max-width: 1887px) {
  .header {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .header h2 {
    font-size: 32pt;
    text-align: center;
    margin-bottom: 15px;
  }
  .detalle-metricas {
    margin-bottom: 20px !important;
    text-align: center;
  }
  .compradores-header {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .compradores-header p {
    margin-bottom: 0 !important;
  }
}
@media (min-width: 1888px) {
  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .header h2 {
    font-size: 32pt;
    text-align: center;
    margin-bottom: 15px;
  }
  .detalle-metricas {
    margin-bottom: 20px !important;
    text-align: center;
  }
  .compradores-header {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .compradores-header p {
    margin-bottom: 0 !important;
  }
}

.container-carousel::-webkit-scrollbar {
  width: 5px;
}

.container-carousel::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

.container-carousel::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #36343f;
}

.vuecal__cell--has-events {
  background-color: rgba(104, 159, 56, 0.2);
}
.vuecal__cell-events-count {
  background-color: rgba(104, 159, 56, 0.8);
  width: 16px;
  height: 16px;
  line-height: 17px;
  font-size: 9pt;
  font-weight: 600;
}

.vuecal__event {
  color: #fff;
  cursor: pointer;
}

.vuecal__event-title {
  padding: 5px 0;
}

.vuecal__event.producto-maracuya {
  background-color: #d8aa18;
}
.vuecal__event.producto-durazno-dorado {
  background-color: #e44f45;
}
.vuecal__event.producto-fresa {
  background-color: #c11419;
}
.vuecal__event.producto-lechuga-verde-crespa {
  background-color: #6d9505;
}
.vuecal__event.producto-tomate-chonto {
  background-color: #f13518;
}
.vuecal__event.producto-cana-de-azucar {
  background-color: #99ad14;
}
.vuecal__event.producto-zanahoria {
  background-color: #ec5909;
}
.vuecal__event.producto-aguacate-hass {
  background-color: #aab464;
}
.vuecal__event.producto-acelga-comun {
  background-color: #466b10;
}
.vuecal__event.producto-yuca {
  background-color: #522718;
}
.vuecal__event.producto-limon-tahiti {
  background-color: #357705;
}
.vuecal__event.producto-cacao {
  background-color: #c47818;
}
.vuecal__event.producto-champinon {
  background-color: #735f43;
}
.vuecal__event.producto-breva {
  background-color: #58343a;
}
.vuecal__event.producto-cebolla-cabezona-papelillo {
  background-color: #b8be75;
}
.vuecal__event.producto-otro {
  background-color: #302e2f;
}
.vuecal__event.producto-pepino-cohombro {
  background-color: #325c2b;
}
.vuecal__event.producto-maiz-tierno {
  background-color: #f7af09;
}
.vuecal__event.producto-tomate-de-arbol {
  background-color: #880f0f;
}
.vuecal__event.producto-papaya-maradol-tainung {
  background-color: #fe9a14;
}
.vuecal__event.producto-mango-tommy {
  background-color: #d5a922;
}
.vuecal__event.producto-ahuyama {
  background-color: #e19701;
}
.vuecal__event.producto-maiz-criollo-amarillo {
  background-color: #d7ac23;
}
.vuecal__event.producto-papa-r12 {
  background-color: #b75d4e;
}
.vuecal__event.producto-uva-isabela {
  background-color: #4b3b5c;
}
.vuecal__event.producto-patilla {
  background-color: #fc493f;
}
.vuecal__event.producto-naranja-valencia {
  background-color: #c98e0e;
}
.vuecal__event.producto-cafe-tipica {
  background-color: #eb0502;
}
.vuecal__event.producto-guanabana {
  background-color: #505c23;
}
.vuecal__event.producto-cafe-caturra {
  background-color: #c31204;
}
.vuecal__event.producto-papa-superior {
  background-color: #846255;
}
.vuecal__event.producto-platano-harton-verde {
  background-color: #6b8538;
}
.vuecal__event.producto-mango-de-azucar {
  background-color: #fca548;
}
.vuecal__event.producto-aguacate-fuerte {
  background-color: #7c8c71;
}
.vuecal__event.producto-aguacate-lorena {
  background-color: #3a7a00;
}
.vuecal__event.producto-canabis-sativa-medicinal {
  background-color: #47693e;
}
.vuecal__event.producto-platano-llanero-verde {
  background-color: #6ba84a;
}
.vuecal__event.producto-mora-de-castilla {
  background-color: #2e1e2c;
}
.vuecal__event.producto-papa-tocarrena {
  background-color: #553736;
}
.vuecal__event.producto-tomillo {
  background-color: #646d1a;
}
.vuecal__event.producto-orellana {
  background-color: #917A70;
}
.vuecal__event.producto-mandarina-arrayana {
  background-color: #FC6D00;
}
.vuecal__event.producto-lulo {
  background-color: #FC820A;
}
.vuecal__event.producto-limon-criollo {
  background-color: #69B047;
}
.vuecal__event.producto-cafe-castillo {
  background-color: #C00100;
}
.vuecal__event.producto-mandarina-oneco {
  background-color: #F1B408;
}
.vuecal__event.producto-pina-golden {
  background-color: #CB9B4C;
}
.vuecal__event.producto-naranja-comun {
  background-color: #DC7F01;
}
.vuecal__event.producto-granadilla {
  background-color: #D17640;
}
.vuecal__event.producto-cebolla-larga {
  background-color: #3C5E30;
}
.vuecal__event.producto-aji-chile {
  background-color: #B22B1C;
}
.vuecal__event.producto-hierbabuena {
  background-color: #74B448;
}

</style>
